<template>
  <div class="text-center">
    <v-dialog fullscreen v-model="dialog">
      <v-card>
        <!-- toolbar -->
        <v-toolbar color="rgba(255, 179, 0, 1)" dense class="elevation-0 white--text">
          <v-toolbar-title>LỌC TÌM KIẾM</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon @click="cancel" class="white--text">close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider />

        <!-- form -->
        <v-form class="pa-2" ref="form">
          <autocomplete-teacher
            v-model="name"
            item-text=""
            item-value=""
            label="Họ tên"
            class="ma-2 mb-4"
            filled
            clearable
            single-line
            hide-details="auto"
            dense
          ></autocomplete-teacher>
          <v-select
            class="ma-2 mb-4"
            single-line
            hide-details="auto"
            filled
            ref="status"
            v-model="status"
            label="Trạng thái"
            dense
            :items="getTeacherStatus"
            item-text="text"
            item-value="value"
          ></v-select>
          <v-select
            :rules="[$rules.required]"
            ref="gender"
            class="ma-2 mb-4"
            v-model="gender"
            label="Giới tính"
            required
            single-line
            dense
            :items="genderOptions"
            filled
            item-text="text"
            item-value="value"
            hide-details="auto"
          ></v-select>
          <v-select
            item-text="text"
            item-value="value"
            class="ma-2 mb-4"
            single-line
            hide-details="auto"
            filled
            ref="month"
            v-model="month"
            label="Tháng sinh"
            dense
            :items="getMonths"
            clearable
          ></v-select>
          <autocomplete-major
            v-model="majors"
            item-text="title"
            item-value="id"
            filled
            class="ma-2 mb-4"
            dense
            label="Chuyên Ngành"
            required
            single-line
            multiple
          ></autocomplete-major>
        </v-form>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="mr-2"
            medium
            depressed
            color="amber dark-1 white--text"
            @click.prevent="onFilterChanged"
            :disabled="isLoading"
          >
            <v-icon left>filter_alt</v-icon>
            <span>Lọc</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import moment from 'moment'
import AutocompleteTeacher from '@/components/basic/input/AutocompleteTeacher'
import AutocompleteMajor from '@/components/basic/input/AutocompleteMajor.vue'
import { genderOptions, getMonths, getTeacherStatus } from '../../helpers'

export default {
  components: {
    AutocompleteTeacher,
    AutocompleteMajor
  },
  data() {
    return {
      query: '',
      loading: 0,
      name: '',
      dialog: false,
      majors: '',
      gender: '',
      status: 'active',
      month: ''
    }
  },
  props: {
    state: Boolean
  },
  computed: {
    getMonths,
    getTeacherStatus() {
      return getTeacherStatus(true)
    },
    genderOptions,
    isLoading() {
      return this.loading > 0
    }
  },
  methods: {
    cancel() {
      this.dialog = false
      this.reset()
      this.$refs.form.reset()
    },
    reset() {
      this.name = ''
    },
    ...mapActions('staff', ['updateStudent']),
    onFilterChanged() {
      this.$emit('onFilterChanged', {
        ...(this.name && { id: this.name }),
        ...(this.major && { majors: this.majors }),
        ...(this.gender && { gender: this.gender }),
        ...(this.status && { status: this.status === 'all' ? '' : this.status }),
        ...(this.month && { month: this.month })
      })
      this.dialog = false
      this.reset()
      this.$refs.form.reset()
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>

<style></style>
